import { useMemo } from 'react';
import { useMutation, useQueryRoles } from '../../index';
import { mutation } from './auth0-edit-organization-member-mutation-builder';
import { buildVariables as buildEditOrganizationMemberVariables } from './auth0-edit-organization-member-mutation-builder';
import permissions from '../../Apollo/permissions';
import mapAuth0UserRoleData from './map-auth0-user-role-data';
import { ORGANIZATION_MEMBERS_QUERY_NAME } from './auth0-organization-members-query-builder';

export default function useEditOrganizationMember({ onCompleted, ...options } = {}) {
  const { roles, loading: auth0RolesLoading } = useQueryRoles();
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.updateUsers },
    onCompleted: data => {
      if (onCompleted) {
        onCompleted(getResponseBody({ data }));
      }
    },
    refetchQueries: [ORGANIZATION_MEMBERS_QUERY_NAME],
    ...options,
  });

  const roleListMap = useMemo(
    () => Object.assign({}, ...roles.map(role => ({ [role.name]: role.id }))),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [auth0RolesLoading]
  );

  const editOrganizationMember = ({ user, roleId, name, email, debuggerAccess }) => {
    const { roleIds } = mapAuth0UserRoleData({ roleListMap, roleId, debuggerAccess });
    return executeMutation({
      variables: buildVariables({ user, roleIds, name, email }),
    });
  };

  return [editOrganizationMember, response];
}

function getResponseBody(response) {
  return response.data.auth0_edit_organization_member;
}

export function buildVariables({ user, roleIds, name, email }) {
  return buildEditOrganizationMemberVariables({ userId: user.id, roleIds, name, email });
}
